// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-sheet-backdrop {
  position: fixed;
  inset: 0;
  background-color: var(--scrim);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  padding-top: env(safe-area-inset-top, 0px);
}

.bottom-sheet-backdrop.visible {
  opacity: 1;
}

.bottom-sheet {
  background: var(--color-surface);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  width: 100vw;
  max-width: 100%;
  max-height: calc(100vh - env(safe-area-inset-top, 0px));
  transform: translateY(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  position: relative;
  box-sizing: border-box;
  border: 1px solid var(--color-border-subtle);
  border-bottom: none;
}

.bottom-sheet.open {
  transform: translateY(0);
}

/* Header: fixed height, never shrinks or scrolls */
.bottom-sheet-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 16px 16px 0 0;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-light-gray);
  min-height: 64px;
  background-color: var(--color-white);
  z-index: 10;
  box-sizing: border-box;
}

.bottom-sheet-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--color-black);
  flex: 1;
  min-width: 0;
}

.bottom-sheet-close {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: var(--color-dark-gray);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;
  min-width: 40px;
  min-height: 40px;
  flex-shrink: 0;
}

.bottom-sheet-close:hover {
  background-color: var(--color-light-gray);
  color: var(--color-black);
}

.bottom-sheet-close:active {
  background-color: var(--color-gray);
}

/* Content: takes remaining space, single scroll container; children control inner scroll */
.bottom-sheet-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 24px;
  background-color: var(--color-white);
  box-sizing: border-box;
}

/* Handle safe areas for devices with notches */
@supports (padding: max(0px)) {
  .bottom-sheet {
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
}

/* Prefer dvh on supported browsers to reduce keyboard resize jump */
@supports (height: 100dvh) {
  .bottom-sheet {
    max-height: calc(100dvh - env(safe-area-inset-top, 0px));
  }
}

/* Focus styles for accessibility */
.bottom-sheet-close:focus {
  outline: 2px solid var(--color-primary-green);
  outline-offset: 2px;
} `, "",{"version":3,"sources":["webpack://./src/components/BottomSheet/BottomSheet.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;EACpD,YAAY;EACZ,eAAe;EACf,uDAAuD;EACvD,2BAA2B;EAC3B,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB;EAChB,oCAAoC;EACpC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2FAA2F;AAC3F;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,wDAAwD;EAC1D;AACF;;AAEA,mCAAmC;AACnC;EACE,6CAA6C;EAC7C,mBAAmB;AACrB","sourcesContent":[".bottom-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: var(--scrim);\n  z-index: 1000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  padding-top: env(safe-area-inset-top, 0px);\n}\n\n.bottom-sheet-backdrop.visible {\n  opacity: 1;\n}\n\n.bottom-sheet {\n  background: var(--color-surface);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  width: 100vw;\n  max-width: 100%;\n  max-height: calc(100vh - env(safe-area-inset-top, 0px));\n  transform: translateY(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-subtle);\n  border-bottom: none;\n}\n\n.bottom-sheet.open {\n  transform: translateY(0);\n}\n\n/* Header: fixed height, never shrinks or scrolls */\n.bottom-sheet-header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  border-radius: 16px 16px 0 0;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--color-light-gray);\n  min-height: 64px;\n  background-color: var(--color-white);\n  z-index: 10;\n  box-sizing: border-box;\n}\n\n.bottom-sheet-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-black);\n  flex: 1;\n  min-width: 0;\n}\n\n.bottom-sheet-close {\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: var(--color-dark-gray);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  min-width: 40px;\n  min-height: 40px;\n  flex-shrink: 0;\n}\n\n.bottom-sheet-close:hover {\n  background-color: var(--color-light-gray);\n  color: var(--color-black);\n}\n\n.bottom-sheet-close:active {\n  background-color: var(--color-gray);\n}\n\n/* Content: takes remaining space, single scroll container; children control inner scroll */\n.bottom-sheet-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 24px;\n  background-color: var(--color-white);\n  box-sizing: border-box;\n}\n\n/* Handle safe areas for devices with notches */\n@supports (padding: max(0px)) {\n  .bottom-sheet {\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n}\n\n/* Prefer dvh on supported browsers to reduce keyboard resize jump */\n@supports (height: 100dvh) {\n  .bottom-sheet {\n    max-height: calc(100dvh - env(safe-area-inset-top, 0px));\n  }\n}\n\n/* Focus styles for accessibility */\n.bottom-sheet-close:focus {\n  outline: 2px solid var(--color-primary-green);\n  outline-offset: 2px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
